module.exports = __webpack_public_path__ + "img/guide-03.5ecb54d5.jpg";